import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

const CLARITY_PLACEHOLDER_ID = 'XXXXXXXXX';

@Injectable({ providedIn: 'root' })
export class ClarityService {

  private readonly projectId = environment.clarityProjectId;

  private scriptLoaded = false;

  init(): void {
    if (this.scriptLoaded || !this.isEnabled()) return;

    try {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.text = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${this.projectId}");
      `;

      document.head.appendChild(script);
      this.scriptLoaded = true;
    } catch {
      this.scriptLoaded = false;
    }
  }

  trackEvent(eventName: string): void {
    if (!this.isEnabled()) return;

    try {
      window.clarity?.('event', eventName);
    } catch {
      return;
    }
  }

  private isEnabled(): boolean {
    return !!this.projectId && this.projectId !== CLARITY_PLACEHOLDER_ID;
  }
}
